import { render, staticRenderFns } from "./StartChatDialog.vue?vue&type=template&id=223a2add&"
import script from "./StartChatDialog.vue?vue&type=script&lang=js&"
export * from "./StartChatDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports